import { createContext, useContext } from "react";
import type { DataSource, StudyImageDto } from "@gazelab/shared";

/**
 * Estado compartido de la pantalla de Resultados: el estímulo elegido y la comparación se
 * conservan al pasar de una imagen a un video (cada tipo tiene su propia vista de análisis).
 */
export interface ResultsShared {
  stimuli: StudyImageDto[];
  loading: boolean;
  error: string | null;
  stimulusId: string;
  setStimulusId: (id: string) => void;
  current: StudyImageDto | null;
  groupA: string;
  setGroupA: (id: string) => void;
  groupB: string;
  setGroupB: (id: string) => void;
  source: DataSource;
  setSource: (s: DataSource) => void;
  includeWarn: boolean;
  setIncludeWarn: (v: boolean) => void;
}

export const ResultsContext = createContext<ResultsShared | null>(null);

export function useResultsShared(): ResultsShared {
  const ctx = useContext(ResultsContext);
  if (!ctx) throw new Error("useResultsShared fuera de StudyResultsPage");
  return ctx;
}
